module.exports = __webpack_public_path__ + "./static/img/icondis-2.6099cb8c80eb37cb7c7fef43f2bc498f.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/img/company/icondis-2.png
// module id = ./client/src/assets/img/company/icondis-2.png
// module chunks = 0